import React from 'react';

const StepProgressBar = ({ step, totalSteps, onBack }) => {
    return (
        <div className="w-full flex justify-between items-center mb-10 px-20">
            {[...Array(totalSteps)].map((_, index) => (
                <div key={index} className="flex items-center">
                    <div
                        className={`w-8 h-8 flex items-center justify-center rounded-full ${
                            index < step ? 'bg-brandDarkBlue text-white' : 'bg-brandGrey text-brandDarkBlue'
                        }`}
                    >
                        {index + 1}
                    </div>
                    {index < totalSteps - 1 && (
                        <div className={`flex-1 h-1 mx-2 ${index < step ? 'bg-brandDarkBlue text-white' : 'bg-brandDarkBlue'}`}></div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default StepProgressBar;
